// src/views/Admin/Companies/components/StatusToggle/StatusToggle.tsx

import React, { useState } from 'react';
import './StatusToggle.scss';

interface StatusToggleProps {
  isActive: boolean;
  onToggle: () => Promise<void>;
  activeLabel?: string;
  inactiveLabel?: string;
  disabled?: boolean;
}

const StatusToggle: React.FC<StatusToggleProps> = ({
  isActive,
  onToggle,
  activeLabel = 'ACTIVA',
  inactiveLabel = 'INACTIVA',
  disabled = false
}) => {
  const [isToggling, setIsToggling] = useState(false);

  const handleToggle = async (e: React.MouseEvent) => {
    e.stopPropagation();
    if (disabled || isToggling) return;

    setIsToggling(true);
    try {
      await onToggle();
    } finally {
      setIsToggling(false);
    }
  };

  return (
    <button
      className={`status-toggle ${isActive ? 'active' : 'inactive'} ${isToggling ? 'toggling' : ''}`}
      onClick={handleToggle}
      disabled={disabled || isToggling}
      title={`Click para ${isActive ? 'desactivar' : 'activar'}`}
    >
      <span className="toggle-track">
        <span className="toggle-thumb">
          {isToggling && <span className="spinner" />}
        </span>
      </span>
      <span className="toggle-label">
        {isActive ? activeLabel : inactiveLabel}
      </span>
    </button>
  );
};

export default StatusToggle;
